export default "__VITE_ASSET__DM4SnZHt__"